var map = {
	"./icon-add-circle.svg": "roxA",
	"./icon-add-square.svg": "U9Dt",
	"./icon-add.svg": "5C8V",
	"./icon-airplane.svg": "7Hjs",
	"./icon-announcement.svg": "D4qf",
	"./icon-application.svg": "jD0+",
	"./icon-archive.svg": "gUg0",
	"./icon-arrow-thick-down-circle.svg": "8SNO",
	"./icon-arrow-thick-left-circle.svg": "z1s3",
	"./icon-arrow-thick-right-circle.svg": "31xq",
	"./icon-arrow-thick-up-circle.svg": "FGhG",
	"./icon-arrow-thin-down-circle.svg": "UpRq",
	"./icon-arrow-thin-left-circle.svg": "ZmEt",
	"./icon-arrow-thin-right-circle.svg": "lCRS",
	"./icon-arrow-thin-up-circle.svg": "NyiP",
	"./icon-arrows-merge.svg": "fRma",
	"./icon-arrows-split.svg": "rXZo",
	"./icon-asterisk.svg": "mT/b",
	"./icon-at.svg": "cqKu",
	"./icon-attach.svg": "MtCT",
	"./icon-battery-full.svg": "hL3y",
	"./icon-battery-half.svg": "cHFz",
	"./icon-bolt.svg": "FsWw",
	"./icon-book-closed.svg": "lWyV",
	"./icon-book-open.svg": "2Hsw",
	"./icon-box.svg": "srbu",
	"./icon-brick.svg": "gE8Q",
	"./icon-bug.svg": "r0MV",
	"./icon-buoy.svg": "Wkcy",
	"./icon-calculator.svg": "E82H",
	"./icon-calendar-add.svg": "t1pX",
	"./icon-calendar-date.svg": "PrFs",
	"./icon-calendar-remove.svg": "ySMZ",
	"./icon-calendar.svg": "pN7w",
	"./icon-camera.svg": "Fz0X",
	"./icon-certificate.svg": "LCpe",
	"./icon-chart.svg": "HTff",
	"./icon-chat-2.svg": "LlE6",
	"./icon-chat-group-alt.svg": "eS32",
	"./icon-chat-group.svg": "N+eu",
	"./icon-chat.svg": "S2Rv",
	"./icon-check.svg": "MtM4",
	"./icon-cheveron-down-circle.svg": "kyht",
	"./icon-cheveron-down.svg": "M5df",
	"./icon-cheveron-left-circle.svg": "g0aa",
	"./icon-cheveron-right-circle.svg": "enOb",
	"./icon-cheveron-selection.svg": "5+ts",
	"./icon-cheveron-up-circle.svg": "MnvV",
	"./icon-cheveron-up.svg": "M7Y5",
	"./icon-click-target.svg": "jQ24",
	"./icon-close-circle.svg": "fGEC",
	"./icon-close-square.svg": "DTe2",
	"./icon-close.svg": "3/wM",
	"./icon-cloud-download.svg": "JQPP",
	"./icon-cloud-upload.svg": "9MpV",
	"./icon-clouds.svg": "COC7",
	"./icon-code.svg": "0Bb5",
	"./icon-cog.svg": "kg5T",
	"./icon-collection.svg": "1Z5U",
	"./icon-compass.svg": "2y5Q",
	"./icon-credit-card.svg": "2fqz",
	"./icon-currency-dollar.svg": "7uIk",
	"./icon-currency-euro.svg": "JHir",
	"./icon-dashboard.svg": "dLfa",
	"./icon-deliver.svg": "Ws9w",
	"./icon-desktop.svg": "3ZRD",
	"./icon-device-smartphone.svg": "hmFy",
	"./icon-device-tablet.svg": "OCL2",
	"./icon-discount.svg": "UuXq",
	"./icon-document-add.svg": "Vy/C",
	"./icon-document-notes.svg": "AGlQ",
	"./icon-document-remove.svg": "nfw7",
	"./icon-document.svg": "Odwb",
	"./icon-door-enter.svg": "ndm7",
	"./icon-door-exit.svg": "tiYM",
	"./icon-dots-horizontal.svg": "WpvR",
	"./icon-dots-vertical.svg": "OGxL",
	"./icon-dupicate.svg": "B2nS",
	"./icon-edit.svg": "U5PA",
	"./icon-external-window.svg": "VMN3",
	"./icon-factory.svg": "JYdT",
	"./icon-fast-forward.svg": "jW59",
	"./icon-fast-rewind.svg": "Q6GM",
	"./icon-film.svg": "UMcb",
	"./icon-flag.svg": "ep/d",
	"./icon-folder-add.svg": "xs4D",
	"./icon-folder-remove.svg": "KO+j",
	"./icon-folder.svg": "F9ET",
	"./icon-globe.svg": "IdMV",
	"./icon-hard-drive.svg": "kssT",
	"./icon-headphones.svg": "LNF7",
	"./icon-heart.svg": "O47h",
	"./icon-help.svg": "Dl3A",
	"./icon-history.svg": "pmHo",
	"./icon-home.svg": "/7Sl",
	"./icon-hour-glass.svg": "dZOT",
	"./icon-identification.svg": "7YJ3",
	"./icon-important.svg": "FH4U",
	"./icon-inbox-check.svg": "rjoh",
	"./icon-inbox-download.svg": "x4pO",
	"./icon-inbox-full.svg": "OTf9",
	"./icon-inbox-upload.svg": "5TQ8",
	"./icon-information.svg": "tLpr",
	"./icon-interface.svg": "xPqq",
	"./icon-key.svg": "jHxS",
	"./icon-launch.svg": "dtrT",
	"./icon-layers.svg": "rhyc",
	"./icon-library.svg": "kFrC",
	"./icon-light.svg": "q82S",
	"./icon-link.svg": "0SVg",
	"./icon-location-pin.svg": "o71k",
	"./icon-lock-open.svg": "cPRt",
	"./icon-lock.svg": "F3Aa",
	"./icon-mail.svg": "ox/D",
	"./icon-map.svg": "m5Ki",
	"./icon-menu.svg": "ew9d",
	"./icon-microphone.svg": "muNL",
	"./icon-money.svg": "bj4n",
	"./icon-monitor.svg": "WbrU",
	"./icon-mood-happy.svg": "USyB",
	"./icon-mood-neutral.svg": "Lo1I",
	"./icon-mood-sad.svg": "+/dO",
	"./icon-news.svg": "1iZo",
	"./icon-notification-off.svg": "NHOt",
	"./icon-notification.svg": "GfP1",
	"./icon-office.svg": "hmh2",
	"./icon-order-horizontal.svg": "kpDr",
	"./icon-order-vertical.svg": "B+1R",
	"./icon-package.svg": "fFsL",
	"./icon-paint.svg": "jxA9",
	"./icon-pause.svg": "NHTM",
	"./icon-phone-incoming-call.svg": "mkTs",
	"./icon-phone-outgoing-call.svg": "GbC+",
	"./icon-phone-ring.svg": "Pgl6",
	"./icon-photo.svg": "Xpl3",
	"./icon-pie-chart.svg": "LdCt",
	"./icon-pin.svg": "+oRF",
	"./icon-play.svg": "59R0",
	"./icon-presentation-play.svg": "KAtI",
	"./icon-presentation.svg": "68km",
	"./icon-print.svg": "5QeN",
	"./icon-puzzle.svg": "95+r",
	"./icon-receipt.svg": "eKx+",
	"./icon-refresh.svg": "JjcL",
	"./icon-remove-circle.svg": "goCY",
	"./icon-remove-square.svg": "L38z",
	"./icon-remove.svg": "yQ6A",
	"./icon-scale.svg": "c+U/",
	"./icon-search.svg": "Eoj0",
	"./icon-security-check.svg": "bVCO",
	"./icon-security-important.svg": "wFK1",
	"./icon-security.svg": "e0dk",
	"./icon-send.svg": "Jpf/",
	"./icon-server.svg": "5PYk",
	"./icon-shopping-bag.svg": "pbOK",
	"./icon-shopping-basket.svg": "8l2a",
	"./icon-shopping-cart.svg": "MBfD",
	"./icon-sign.svg": "d4tB",
	"./icon-sort-ascending.svg": "nId+",
	"./icon-sort-decending.svg": "rFu6",
	"./icon-star.svg": "18Dw",
	"./icon-stop.svg": "lk77",
	"./icon-store.svg": "MB9t",
	"./icon-survey.svg": "xm/Z",
	"./icon-swatch.svg": "8muV",
	"./icon-tag.svg": "vfMD",
	"./icon-target.svg": "rBPl",
	"./icon-text-cursor.svg": "J//v",
	"./icon-thermostat-full.svg": "VMN1",
	"./icon-thermostat-half.svg": "5Nua",
	"./icon-thumbs-down.svg": "/oq9",
	"./icon-thumbs-up.svg": "wq3u",
	"./icon-ticket.svg": "GLj7",
	"./icon-time.svg": "5BbZ",
	"./icon-translate.svg": "1Vx0",
	"./icon-trash.svg": "9K6U",
	"./icon-trending-down.svg": "7VMy",
	"./icon-trending-up.svg": "xi21",
	"./icon-trophy.svg": "lIB0",
	"./icon-tune.svg": "hDib",
	"./icon-umbrella.svg": "SS3P",
	"./icon-user-add.svg": "nZiX",
	"./icon-user-check.svg": "olnK",
	"./icon-user-circle.svg": "SqF5",
	"./icon-user-couple.svg": "q8ft",
	"./icon-user-group.svg": "xihg",
	"./icon-user-remove.svg": "wb1Q",
	"./icon-user.svg": "rPma",
	"./icon-videocam.svg": "PqDl",
	"./icon-view-hidden.svg": "4c6/",
	"./icon-view-visible.svg": "IW4A",
	"./icon-volume-down.svg": "cMTb",
	"./icon-volume-mute.svg": "mPUK",
	"./icon-volume-up.svg": "kuU9",
	"./icon-wallet.svg": "IsLZ",
	"./icon-widget-add.svg": "SBcu",
	"./icon-wifi-off.svg": "KZ7l",
	"./icon-wifi.svg": "BVOo",
	"./icon-work.svg": "udKs",
	"./icon-zoom-in.svg": "MyPa",
	"./icon-zoom-out.svg": "Milr"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dAZ6";